import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Message from 'components/text/Message/Message'
import VisuallyHidden from 'components/ui/VisuallyHidden/VisuallyHidden'

import s from './PriceWithDiscount.scss'
import messages from './messages'


const PriceWithDiscount = ({ className, price }) => (
  <ins className={cx(s.priceWithDiscount, className)}>
    <VisuallyHidden>
      <Message text={messages.text} />
    </VisuallyHidden>
    {price}
  </ins>
)

PriceWithDiscount.propTypes = {
  className: PropTypes.string,
  price: PropTypes.string,
}


export default PriceWithDiscount
